import { BaseService } from '../../../../core/services/base.service';
import { Observable } from 'rxjs';
import { PageResponse } from '../../../../core/interfaces/page-response.interface';
import { CommonSearchParam } from '../../../../core/interfaces/common-search-param.interface';
import { Profile, Experience, Education } from '../../interfaces/profile/profile.interface';

export abstract class ProfileCompletionService extends BaseService<Profile> {
    findAll(searchParam: CommonSearchParam): Observable<PageResponse<Profile>> { throw new Error('Not implemented'); }
    find(id: string): Observable<Profile> { throw new Error('Not implemented'); }
    create(data: Partial<Profile>): Observable<Profile> { throw new Error('Not implemented'); }
    update(id: string, data: Partial<Profile>): Observable<Profile> { throw new Error('Not implemented'); }

    abstract getProfileDetails(): Observable<Profile>;
    abstract updateBasicInfo(data: Profile): Observable<Profile>;
    abstract updateUserType(userType: string): Observable<void>;
    abstract uploadProfilePicture(uniqueId: string, file: File, isPrimary: boolean): Observable<any>;
    abstract updateSkills(data: { skills: string[], careerObjective: string }): Observable<any>;

    // Education
    abstract createOrUpdateEducation(data: Education[]): Observable<Education[]>;
    abstract getCurrentUserEducation(): Observable<Education[]>;
    abstract deleteEducation(uniqueId: string): Observable<void>;

    // Work Experience
    abstract createWorkExperience(data: Experience[]): Observable<Experience[]>;
    abstract updateWorkExperience(uniqueId: string, data: Experience): Observable<Experience>;
    abstract getCurrentWorkExperience(): Observable<Experience[]>;
    abstract deleteExperience(uniqueId: string): Observable<void>;
    abstract getExperiencedProjects(): Observable<any>;
    abstract getExperienceRange(): Observable<any>;
}
